module.exports = __webpack_public_path__ + "static/media/Gravic.56143d10.png";